import * as React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Circle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 18px;
  margin-right: 10px;
`;

const getInitials = name => {
  const nameArray = name.split(' ');
  const initials = nameArray.map(n => n[0]).join('');
  return initials.toUpperCase();
};

const UserAvatar = ({ name }) => {
  return (
    <Wrapper>
      <Circle>{getInitials(name)}</Circle>
    </Wrapper>
  );
};

export default UserAvatar;
